//	User Setings
var hosecalc_setting_lineColor='#00FF40';
var hosecalc_setting_calloutcolor='#A00A6E';
var hosecalc_setting_maptype='satellite';			//Set to 'roadmap' or 'satellite'
var hosecalc_setting_NumberofDecimalPlaces=0;
var hosecalc_setting_lineWeight=3;
var hosecalc_setting_showFullScreenButton = false;
var hosecalc_setting_ftmeasurementareabgcolor = '#ECFE2C'; //Background color of measurement bubble
var hosecalc_setting_zoomtoaddress=21;
//	User Setings



var hosecalc_setting_boolDebugMode=false;